// pendingSlot.ts
// T-115 (v1.8.31, 27.09.2026): Öffentliche Terminansicht ohne Anmeldung (Kundin 26.09.2026, Erik-Entscheidung 27.09.:
// Restpunkt ohne Aufpreis). Klickt ein nicht angemeldeter Besucher im Buchungskalender auf einen Termin, merkt sich
// der Browser Datum und Uhrzeit. Nach Anmeldung (auch nach Registrierung und E-Mail-Bestätigung im selben Browser)
// öffnet der Kalender diesen Termin wieder. Gültig 24 Stunden, danach verworfen. Nur Datum und Uhrzeit, keine
// personenbezogenen Daten. localStorage kann gesperrt sein (privater Modus): dann entfällt nur die Komfortfunktion.

export interface PendingSlot {
  /** Termin-Datum im Format YYYY-MM-DD */
  date: string;
  /** Uhrzeit wie vom Kalender geliefert (HH:mm oder HH:mm:ss) */
  time: string;
  /** Zeitpunkt des Merkens (ms seit 1970) */
  savedAt: number;
}

const STORAGE_KEY = 'ff_pending_slot';
export const PENDING_SLOT_MAX_AGE_MS = 24 * 60 * 60 * 1000;

const DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const TIME_PATTERN = /^\d{2}:\d{2}(:\d{2})?$/;

/** Prüft einen gelesenen Wert (reine Funktion, testbar). */
export const parsePendingSlot = (raw: string | null, now: number = Date.now()): PendingSlot | null => {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (!value || typeof value !== 'object') return null;
    if (typeof value.date !== 'string' || !DATE_PATTERN.test(value.date)) return null;
    if (typeof value.time !== 'string' || !TIME_PATTERN.test(value.time)) return null;
    if (typeof value.savedAt !== 'number' || !isFinite(value.savedAt)) return null;
    if (now - value.savedAt > PENDING_SLOT_MAX_AGE_MS || value.savedAt - now > 60 * 1000) return null;
    return { date: value.date, time: value.time, savedAt: value.savedAt };
  } catch {
    return null;
  }
};

export const savePendingSlot = (date: string, time: string): void => {
  if (!DATE_PATTERN.test(date) || !TIME_PATTERN.test(time)) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ date, time, savedAt: Date.now() }));
  } catch {
    // Speicher gesperrt: Termin wird nach der Anmeldung nicht automatisch geöffnet
  }
};

export const clearPendingSlot = (): void => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignorieren
  }
};

/** Liest den gemerkten Termin; ungültige oder abgelaufene Einträge werden entfernt. */
export const loadPendingSlot = (): PendingSlot | null => {
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
  const slot = parsePendingSlot(raw);
  if (!slot && raw) clearPendingSlot();
  return slot;
};

export const hasPendingSlot = (): boolean => loadPendingSlot() !== null;
